/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var MfaFactorType;

(function (MfaFactorType) {
  MfaFactorType["TOTP"] = "totp";
  MfaFactorType["SMS"] = "sms";
})(MfaFactorType || (MfaFactorType = {}));